export default {
    methods: {
        /**
         * Get period text for language.
         *
         * @param {Object} period
         * @param {String} type
         * @param event
         */
        getPeriodText(period, type) {
            for (let text of period.texts) {
                if (text.language !== this.$i18n.locale) {
                    continue;
                }

                return text[type] || '';
            }

            return '';
        }
    }
}
